/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { MasterImportResponse } from '../model/masterImportResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class LoanTypeCodeControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingDELETE5(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingDELETE5(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingDELETE5(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingDELETE5(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Array<MasterImportResponse>>(`${this.basePath}/import/Loan/typecode/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingGET5(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingGET5(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingGET5(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingGET5(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MasterImportResponse>>(`${this.basePath}/import/Loan/typecode/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingHEAD5(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingHEAD5(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingHEAD5(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingHEAD5(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<Array<MasterImportResponse>>(`${this.basePath}/import/Loan/typecode/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingOPTIONS5(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingOPTIONS5(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS5(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS5(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<Array<MasterImportResponse>>(`${this.basePath}/import/Loan/typecode/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPATCH5(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPATCH5(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPATCH5(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPATCH5(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<Array<MasterImportResponse>>(`${this.basePath}/import/Loan/typecode/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPOST5(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPOST5(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPOST5(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPOST5(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Array<MasterImportResponse>>(`${this.basePath}/import/Loan/typecode/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPUT5(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPUT5(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPUT5(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPUT5(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<Array<MasterImportResponse>>(`${this.basePath}/import/Loan/typecode/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrChargeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrChargeTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrChargeTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCharge`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrChargeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrChargeTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrChargeTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCharge`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrChargeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrChargeTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrChargeTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCharge`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrChargeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrChargeTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrChargeTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCharge`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrChargeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrChargeTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrChargeTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCharge`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrChargeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrChargeTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrChargeTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCharge`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrChargeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrChargeTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrChargeTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrChargeTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCharge`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrCollectionTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrCollectionTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrCollectionTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCollection`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrCollectionTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrCollectionTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrCollectionTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCollection`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrCollectionTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrCollectionTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrCollectionTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCollection`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrCollectionTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrCollectionTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrCollectionTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCollection`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrCollectionTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrCollectionTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrCollectionTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCollection`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrCollectionTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrCollectionTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrCollectionTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCollection`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrCollectionTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrCollectionTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrCollectionTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrCollectionTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrCollection`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrServiceTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrServiceTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrServiceTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrService`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrServiceTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrServiceTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrServiceTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrService`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrServiceTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrServiceTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrServiceTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrService`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrServiceTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrServiceTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrServiceTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrService`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrServiceTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrServiceTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrServiceTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrService`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrServiceTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrServiceTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrServiceTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrService`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndIntrServiceTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndIntrServiceTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndIntrServiceTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndIntrServiceTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/intrService`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndRepayTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndRepayTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndRepayTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndRepayTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndRepayTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/indRepay`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndRepayTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndRepayTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndRepayTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndRepayTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndRepayTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/indRepay`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndRepayTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndRepayTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndRepayTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndRepayTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndRepayTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/indRepay`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndRepayTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndRepayTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndRepayTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndRepayTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndRepayTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/indRepay`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndRepayTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndRepayTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndRepayTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndRepayTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndRepayTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/indRepay`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndRepayTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndRepayTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndRepayTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndRepayTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndRepayTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/indRepay`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importIndRepayTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importIndRepayTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importIndRepayTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importIndRepayTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importIndRepayTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Loan/typecode/indRepay`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
